import React, {Component} from 'react';
import {connect} from 'react-redux';
import {convertTimeCreditToPcBangPoint, formatUtcDateToLocalDateFormat} from '../../../../util/timeUtils';
import commaNumber from 'comma-number';
import {submitRefundRequest} from '../../../../actions/refundRequest.actions';
import {createPaymentCancelRequest} from '../../../../actions/paymentCancelRequest.action';
import {fetchProductEntitlementsWithPurchasesForCurrentUser} from '../../../../actions/usageStatus.actions';
import {getRefundAmount, isCancellableEntitlement, isRefundableEntitlement} from '../../../../util/refundAndCancelUtil';
import {Button, ButtonGroup, Table, BulletList, PageSubTitle, PcBangPopup} from '../../../Common/PageComponents';
import {fetchCurrentUserDetailRequest, patchUserAutoPayment} from '../../../../actions/user.actions';
import './refund.scss';
import {RefundAgreements} from './RefundAgreements';

const stateToProps = state => {
  return {
    ownerName: state.user.ownerName,
    pcBangName: state.user.pcBangName,
    productEntitlements: state.usageStatus.productEntitlements,
    purchases: state.purchase.purchases,
    autoPayment: state.user.autoPayment,
  };
};

export class RefundApplicationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestType: undefined,
      productEntitlementId: undefined,
      submitButtonDisabled: false,
      autoPaymentGuideModalOpen: false,
      autoPaymentGuideConfirmed: false,
    };
  }

  _onProductEntitlementSelectChanged(e, entitlement, purchase) {
    if (!purchase) {
      this.setState({
        requestType: undefined,
        productEntitlementId: undefined,
      });
      return;
    }

    let productEntitlementId = e.target.value;

    if (isCancellableEntitlement(entitlement, purchase)) {
      this.setState({
        requestType: 'CANCEL',
        productEntitlementId: productEntitlementId,
      });
      return;
    }

    this.setState({
      requestType: 'REFUND',
      productEntitlementId: productEntitlementId,
    });
  }

  _confirmTheAgreementOfAutoPaymentGuide() {
    this.setState({autoPaymentGuideConfirmed: true});
  }

  _submitRefundApplication() {
    if (
      this.props.autoPayment &&
      this.props.autoPayment.paused == false &&
      this.isConfirmedAutoPaymentGuide() == false
    ) {
      this._openAutoPaymentGuideModal();
      return;
    }

    if (this.state.submitButtonDisabled) {
      alert('환불/취소 요청 작업을 처리중입니다.');
      return;
    }

    if (!this.state.productEntitlementId) {
      alert('취소/환불 상품을 선택하세요.');
      return;
    }

    if (!this.form.reason.value) {
      alert('취소/환불 사유를 선택해주세요.');
      return;
    }

    if (!this.state.productEntitlementId) {
      alert('취소/환불 상품을 선택하세요.');
      return;
    }

    if (!this.form.yn0.checked || !this.form.yn1.checked) {
      alert('개인정보관련 동의서에 동의해주세요.');
      return;
    }

    if (this.state.requestType === 'REFUND') {
      if (
        !this.form.reason.value ||
        !this.form.bankName.value ||
        !this.form.accountHolder.value.trim() ||
        !this.form.accountNumber.value.trim()
      ) {
        alert('미기입된 환불 정보가 있습니다.');
        return;
      }
      this.setState({submitButtonDisabled: true});
      submitRefundRequest(
        this.form.reason.value,
        this.state.productEntitlementId,
        this.form.bankName.value,
        this.form.accountHolder.value,
        this.form.accountNumber.value,
        this.props.history
      );
    } else if (this.state.requestType === 'CANCEL') {
      this.setState({submitButtonDisabled: true});
      createPaymentCancelRequest(this.state.productEntitlementId, this.form.reason.value, this.props.history);
      return;
    }
  }

  isConfirmedAutoPaymentGuide() {
    return this.state.autoPaymentGuideConfirmed == true;
  }

  _openAutoPaymentGuideModal() {
    this.setState({autoPaymentGuideModalOpen: true});
  }

  _filterBankAccountNumberInput(e) {
    let key = e.key;

    if (!key.match(/[0-9]/)) {
      e.preventDefault();
      return;
    }
  }

  _pauseAutoPayment() {
    let pausedAutoPayment = {paused: true};
    this.props.dispatch(patchUserAutoPayment(pausedAutoPayment));
  }

  _removeSpecialCharactersExceptNumbers(e) {
    e.target.value = e.target.value.replace(/[^\d]/g, '');
  }

  componentDidMount() {
    this.props.dispatch(fetchProductEntitlementsWithPurchasesForCurrentUser());
    this.props.dispatch(fetchCurrentUserDetailRequest());
  }

  render() {
    return (
      <div className="refuld-application-form">
        <PageSubTitle title="환불 신청 안내" />
        <form name="refund-request" ref={form => (this.form = form)}>
          <Table theme="form">
            <colgroup>
              <col width={140} />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>상호</th>
                <td>{this.props.pcBangName}</td>
              </tr>
              <tr>
                <th>대표자 이름</th>
                <td>{this.props.ownerName}</td>
              </tr>
              <tr>
                <th>사유</th>
                <td>
                  <select name="reason">
                    <option value="">취소/환불 사유 선택</option>
                    <option value="폐업">폐업</option>
                    <option value="명의변경">명의변경</option>
                    <option value="상품변경">상품변경</option>
                    <option value="계약해지">계약해지</option>
                    <option value="중복결제">중복결제</option>
                    <option value="오입금">오입금</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>상품명</th>
                <td>
                  <Table theme="form" className="refuld-application-form__product-table">
                    <colgroup>
                      <col width={50} />
                      <col width={100} />
                      <col width={120} />
                      <col width={120} />
                      <col width={100} />
                      <col width="*" />
                      <col width={100} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>선택</th>
                        <th>상품명</th>
                        <th>유효기간</th>
                        <th>결제일</th>
                        <th>결제액</th>
                        <th>잔여포인트</th>
                        <th>환불금액</th>
                      </tr>
                    </thead>
                    <tbody>{this._renderProductEntitlements()}</tbody>
                  </Table>
                </td>
              </tr>
              <tr>
                <th>개인정보 동의</th>
                <td>
                  <RefundAgreements />
                </td>
              </tr>
            </tbody>
            {this.state.requestType === 'REFUND' ? this._renderRefundRequestForm() : null}
            {this.state.requestType === 'CANCEL' ? this._renderCancelRequestForm() : null}
          </Table>
        </form>
        <ButtonGroup>
          <Button size="small" onClick={() => this._submitRefundApplication()} data-qa="refundApplyButton">
            신청하기
          </Button>
        </ButtonGroup>
        <div>
          <PageSubTitle title={'주의사항'} />
          환불 및 결제취소 신청접수가 완료될 경우 신청하신 상품은 서비스가 중지됩니다. <br />
          다른 이용상품이 없을 경우 라이엇 게임즈 프리미엄 PC방 혜택을 이용할 수 없으니 신청에 신중해 주시기 바랍니다.
        </div>
        <BulletList>
          <PageSubTitle title={'결제취소 안내'} />
          <ul>
            <li>모든 결제 취소는 7일 이내에 하셔야 환불수수료가 발생하지 않습니다. (결제일 기준 7일)</li>
            <li>단, 7일 안이라 할지라도 소진 내역이 있으면 환불수수료가 발생합니다.</li>
            <li>시간 소진을 원하지 않을 경우 (MY PC방 &gt; PC방 관리 &gt; IP 관리)에서 IP를 삭제해주십시오.</li>
          </ul>
        </BulletList>
        <BulletList>
          <PageSubTitle title={'환불 안내'} />
          <ul>
            <li>환불 신청은 대표자 명의 통장으로만 신청 가능합니다.</li>
            <li>
              대표자 명의의 통장이 아닐 경우 환불신청만 가능하며 환불신청서를 출력하여 작성하신 후 대표자명의 통장사본,
              대표자명의 신분증 사본과 함께 팩스 또는 고객센터로 보내주시면 확인 후 처리해 드리고 있습니다.
            </li>
            <li>환불 신청서의 경우 대표자님의 자필서명 또는 도장이 반드시 기입되어 있어야 합니다.</li>
            <li>환불 신청 후 입금은 신청일 기준 최대 7일정도 소요될 수 있습니다.</li>
            <li>환불 금액이 환불수수료보다 금액이 낮을 경우 환불처리가 불가능합니다.</li>
            <li>고객센터 FAX번호는 02-863-4580 입니다.</li>
          </ul>
        </BulletList>
        {this._renderAutoPaymentPauseGuideModal()}
      </div>
    );
  }

  _renderProductEntitlements() {
    let {productEntitlements = [], purchases} = this.props;
    productEntitlements = productEntitlements.filter(entitlement => isRefundableEntitlement(entitlement));
    if (productEntitlements.length === 0) {
      return (
        <tr>
          <td colSpan={7} style={{textAlign: 'center'}}>
            취소/환불 가능한 상품내역이 없습니다.
          </td>
        </tr>
      );
    }
    return productEntitlements.map(entitlement => {
      let purchase = purchases[entitlement.entitlementId];
      if (purchase) {
        return (
          <tr key={entitlement.entitlementId}>
            <td>
              <input
                type="radio"
                name="productEntitlementId"
                value={entitlement.entitlementId}
                onChange={e => this._onProductEntitlementSelectChanged(e, entitlement, purchase)}
              />
            </td>
            <td>{entitlement.name}</td>
            <td>{formatUtcDateToLocalDateFormat(purchase.expirationDate)}</td>
            <td>{formatUtcDateToLocalDateFormat(purchase.created)}</td>
            <td>{commaNumber(purchase.payment.price)} 원</td>
            <td>{convertTimeCreditToPcBangPoint(entitlement.remainingTimeCredit)}</td>
            <td>{getRefundAmount(entitlement, purchase)} 원</td>
          </tr>
        );
      }
    });
  }

  _renderRefundRequestForm() {
    return (
      <tbody>
        <tr>
          <th>은행명</th>
          <td>
            <select name="bankName" style={{width: 122}}>
              <option value="">==선택==</option>
              <option value="산업은행">산업은행</option>
              <option value="기업은행">기업은행</option>
              <option value="국민은행">국민은행</option>
              <option value="수협">수협</option>
              <option value="농협(중앙회)">농협(중앙회)</option>
              <option value="농협(단위농협)">농협(단위농협)</option>
              <option value="축협(중앙회)">축협(중앙회)</option>
              <option value="축협(단위축협)">축협(단위축협)</option>
              <option value="우리은행">우리은행</option>
              <option value="조흥은행">조흥은행</option>
              <option value="제일은행">제일은행</option>
              <option value="하나은행(구 서울은행)">하나은행(구 서울은행)</option>
              <option value="신한은행">신한은행</option>
              <option value="대구은행">대구은행</option>
              <option value="부산은행">부산은행</option>
              <option value="광주은행">광주은행</option>
              <option value="제주은행">제주은행</option>
              <option value="전북은행">전북은행</option>
              <option value="경남은행">경남은행</option>
              <option value="씨티은행">씨티은행</option>
              <option value="우체국">우체국</option>
              <option value="KEB하나은행">KEB하나은행</option>
              <option value="우리은행(구 평화은행)">우리은행(구 평화은행)</option>
              <option value="새마을금고">새마을금고</option>
              <option value="신협">신협</option>
              <option value="케이뱅크">케이뱅크</option>
              <option value="카카오뱅크">카카오뱅크</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>계좌번호</th>
          <td>
            <input
              name="accountNumber"
              type="text"
              className="input_text"
              autoComplete="off"
              onChange={e => this._removeSpecialCharactersExceptNumbers(e)}
              onKeyPress={e => this._filterBankAccountNumberInput(e)}
              style={{width: 282, imeMode: 'disabled'}}
            />
            &nbsp;
          </td>
        </tr>
        <tr>
          <th>예금주</th>
          <td>
            <input
              name="accountHolder"
              maxLength={10}
              type="text"
              autoComplete="off"
              className="input_text"
              style={{width: 282}}
            />
            &nbsp;
          </td>
        </tr>
        <tr>
          <th>결제자</th>
          <td>{this.props.ownerName}</td>
        </tr>
        <tr>
          <th>환불 방법</th>
          <td>환불 신청</td>
        </tr>
      </tbody>
    );
  }

  _renderCancelRequestForm() {
    return (
      <tbody>
        <tr>
          <th>결제자</th>
          <td>{this.props.ownerName}</td>
        </tr>
        <tr>
          <th>환불방법</th>
          <td>결제 취소</td>
        </tr>
      </tbody>
    );
  }

  _renderAutoPaymentPauseGuideModal() {
    return (
      <PcBangPopup
        open={this.state.autoPaymentGuideModalOpen}
        contentStyle={{width: '500px'}}
        onClose={() => this.setState({autoPaymentGuideModalOpen: false})}
        title={'자동결제 일시정지 안내'}
      >
        <div className="auto-payment-guide">
          <strong>결제취소/환불 주의 사항</strong>
          <br />
          <br />
          <dl>
            <dt>■</dt>
            <dd>
              <b>주의 사항</b>
              <br />
            </dd>
            <dt>1.</dt>
            <dd>
              자동결제 일시정지가 설정되지 않을 경우, 결제취소/환불과 무관하게 결제가 자동으로 발생할 수 있습니다.
            </dd>
            <dt>2.</dt>
            <dd>일시정지된 자동결제는 향후 자동결제신청/변경 페이지에서 해제할 수 있습니다.</dd>
            <dt>3.</dt>
            <dd>아래 결제취소/환불 진행 버튼을 눌러 계속할 경우 자동결제는 일시정지되지 않습니다.</dd>
          </dl>
        </div>
        <ButtonGroup>
          <Button
            onClick={() => {
              this._pauseAutoPayment();
              this.setState({autoPaymentGuideModalOpen: false});
            }}
          >
            자동결제 일시정지
          </Button>
          <Button
            theme={'gray'}
            onClick={() => {
              this._confirmTheAgreementOfAutoPaymentGuide();
              this.setState({autoPaymentGuideModalOpen: false});
            }}
          >
            결제취소/환불 진행
          </Button>
        </ButtonGroup>
      </PcBangPopup>
    );
  }
}

export default connect(stateToProps)(RefundApplicationForm);
